import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll () {
    return store.dispatch('checkResponseApi', await Api().get('log/error/front'))
  },

}



// WEBPACK FOOTER //
// ./src/api/LogErrorFrontService.js